import {isDefined} from '@ls/js-utils';
import CalcType from 'state/Constants/CalcType';
import ScaleType from 'state/Constants/ScaleType';
import scope from './scope';

export default class BetaDefinition {
  #betaId;
  #betaFactor;
  #covarianceType;
  #calcType;
  #scaleType;

  constructor(props = {}) {
    const {betaId, betaFactor, covarianceType, calcType, scaleType} = props;
    this.#betaId = betaId;
    this.#betaFactor = betaFactor;
    this.#covarianceType = covarianceType;
    this.#calcType = calcType;
    this.#scaleType = scaleType;
  }

  get betaId() {
    return this.#betaId;
  }

  get betaFactor() {
    return this.#betaFactor;
  }

  get covarianceType() {
    return this.#covarianceType;
  }

  get calcType() {
    return this.#calcType;
  }

  get scaleType() {
    return this.#scaleType;
  }

  get key() {
    return `${scope} - ${this.#betaId}, ${this.#betaFactor}, ${this.#covarianceType}, ${this.#calcType}, ${this.#scaleType}`;
  }

  get complete() {
    return isDefined(this.#betaId) && isDefined(this.#betaFactor) && isDefined(this.#covarianceType) && isDefined(this.#calcType) && isDefined(this.#scaleType);
  }

  get betaType() {
    return `${this.#betaId}-${this.#covarianceType}`;
  }

  static getDefault = () => new BetaDefinition({
    betaId: 3,
    betaFactor: 'TOTAL',
    covarianceType: 'HIST',
    calcType: CalcType.Account,
    scaleType: ScaleType.Contribution,
  });
  copy = () => ({
    betaId: this.#betaId,
    betaFactor: this.#betaFactor,
    covarianceType: this.#covarianceType,
    calcType: this.#calcType,
    scaleType: this.#scaleType,
  });
  setBetaId = (value) => new BetaDefinition({
    ...this.copy(),
    betaId: value,
  });
  setBetaFactor = (value) => new BetaDefinition({
    ...this.copy(),
    betaFactor: value,
  });
  setCovarianceType = (value) => new BetaDefinition({
    ...this.copy(),
    covarianceType: value,
  });
  setCalcType = (value) => new BetaDefinition({
    ...this.copy(),
    calcType: value,
  });
  setScaleType = (value) => new BetaDefinition({
    ...this.copy(),
    scaleType: value,
  });
}
